// Lib
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

// Actions
import { closePopup } from '../../components/popupPanel/popupActions';

// Components
import Toast from '../../structural/toast/Toast';
import PopupVisible from '../../components/popupPanel/PopupVisible';
import ToastDismissButton from '../../structural/toast/ToastDismissButton';

// Constants
import { PopupIds } from '../../components/popupPanel/popupConstants';

const ExportingZipAlertToast = () => {
    const dispatch = useDispatch();
    const dispatchClosePopup = useCallback(() => dispatch(closePopup(PopupIds.EXPORT_BOARD, false)), []);

    return (
        <PopupVisible popupId={PopupIds.EXPORT_BOARD}>
            <Toast>
                <p>Generating ZIP file, we&apos;ll email you a link when it&apos;s ready</p>
                <ToastDismissButton onClick={dispatchClosePopup} />
            </Toast>
        </PopupVisible>
    );
};

export default ExportingZipAlertToast;
